import { createSelector } from 'reselect'
import { TradeOrderSideEnum } from '@sparling/financial-common'
import { RootState } from '../types'
import { orderSideSelector } from './app'

export const currentNameInstrumentSelector = (state: RootState): RootState['instruments']['currentInstrument'] =>
  state.instruments.currentInstrument

export const getInstrumentsLoadingState = (
  state: RootState,
): RootState['instruments']['tradableInstruments']['status'] => state.instruments.tradableInstruments.status

export const getInstrumentsIsLoading = createSelector(
  getInstrumentsLoadingState,
  (state): boolean => state === 'LOADING',
)

export const instrumentsAllSelector = createSelector(
  (state: RootState): RootState['instruments']['tradableInstruments']['data'] =>
    state.instruments.tradableInstruments.data,
  (instruments) => instruments,
)

export const instrumentsSelector = createSelector(
  (state: RootState): RootState['instruments']['tradableInstruments']['data'] =>
    state.instruments.tradableInstruments.data,
  (instruments) => instruments.filter((instrument) => instrument.isTradable),
)

export const currentInstrumentSelector = createSelector(
  currentNameInstrumentSelector,
  instrumentsSelector,
  (current, instruments) => instruments.find((instrument) => instrument.name === current),
)

export const instrumentsOptionsSelector = createSelector([instrumentsSelector], (instruments) =>
  instruments.map((inst) => {
    const base = inst.underlier.slice(0, 3)
    const quote = inst.underlier.slice(3)
    return {
      value: inst.name,
      label: `${base} / ${quote}`,
    }
  }),
)

export const currentPriceSelector = createSelector(
  instrumentsSelector,
  currentNameInstrumentSelector,
  orderSideSelector,
  (instruments, instrumentName, orderSide) => {
    const instrument = instruments.find((inst) => inst.name === instrumentName)
    return (
      {
        [TradeOrderSideEnum.BUY]: instrument?.ask,
        [TradeOrderSideEnum.SELL]: instrument?.bid,
      }[orderSide] || 0
    )
  },
)
